import { BusyIndicator, Portal } from "client/Components";
import { AlertManager, useAlerts } from "client/Hooks";
import { openDocument } from "client_legacy/Documents/SharePoint/documentOpener";
import { DocumentItemViewModel } from "client/Api/Documents/SharePoint/common";
import { ReactElement, useEffect } from "react";
import { localize } from "client_legacy/ndaw/culture";
import { getDocumentInformation } from "client/Api/Documents/SharePoint/sharepointDocuments";
import { DocumentShareNotificationDataViewModel } from "client/Api/Notifications/notifications";
import { HttpRequestError } from "client/Api/httpClient";

export type DocumentSharedActivityInvocationProps = {
	data: DocumentShareNotificationDataViewModel;
	onDismiss: () => void;
};

export const DocumentSharedActivityInvocation = (props: DocumentSharedActivityInvocationProps): ReactElement | null => {
	const {
		data,
		onDismiss
	} = props;

	const alertManager: AlertManager = useAlerts();

	useEffect(
		() => {
			const {
				documentItemId,
				location
			} = data;

			async function fetchAndOpenDocument(): Promise<void> {
				try {
					const document: DocumentItemViewModel = await getDocumentInformation(location, documentItemId);
					openDocument(document);
					onDismiss();
				} catch (e) {
					if (e instanceof HttpRequestError && e.statusCode === 404) {
						alertManager.showError(localize("_CantOpenThisItem"));
					} else {
						console.error(e);
						alertManager.showError(localize("_GeneralErrorMessage"));
					}
					onDismiss();
				}
			};

			fetchAndOpenDocument();
		},
		[
			alertManager,
			data,
			onDismiss
		]
	);

	return (
		<Portal container={document.body}>
			<BusyIndicator/>
		</Portal>
	);
};

DocumentSharedActivityInvocation.displayName = "DocumentSharedActivityInvocation";